import React, {useState, useEffect} from 'react'
import firebase from '../../firebase/config'
import {Link, Redirect, useHistory} from 'react-router-dom';
import moment from 'moment';
import AgendaConfig from '../AgendaConfig';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, TimePicker } from '@material-ui/pickers';
import ModalGuide from '../../components/ModalGuide';
import Utils from '../../firebase/utils';
import Compress from "react-image-file-resizer";

function Services() {

    const history = useHistory()  
    const hiddenFileInput = React.useRef(null);
    const [btnMessage, setBtnMessage] = useState("Crear servicio");
    const [LPID, setLPID] = useState("");
    const [localidadId, setLocalidadId] = useState("");
    const [services, setServices] = useState([])
    const [localidades, setLocalidades] = useState([])
    const [localidadesVarias, setLocalidadesVarias] = useState([])
    const [user, setUser] = useState({})
    const [delivery, setDelivery] = useState(false)
    const [allLocalidades, setAllLocalidades] = useState(false)
    const [domicilio, setDomicilio] = useState(false)
    const [tipoServicios, setTipoServicios] = useState([])
    const [tiposCate, setTiposCate] = useState([])
    const [service, setService] = useState({})

    const [day, setDay] = useState({})
    const [agendaDays, setAgendaDays] = useState([])
    const [horas, setHoras] = useState([])
    
    const tipoUnidad = ["El servicio se cobra por:", "Monto del servicio", "Hora", "Noche", "Día"]
    const [deleteModal, setDeleteModal] = useState(false);
    const [update, setUpdate] = useState(false);
    const [showLocalidadesModal, setShowLocalidadesModal] = useState(false);
    const [editAgenda, setEditAgenda] = useState(false);
    const [contieneAgenda, setContieneAgenda] = useState(false);
    const [palabra, setPalabra] = useState("")
    const [palabrasClave, setPalabrasClave] = useState([])
    const [countryInfo, setCountryInfo] = useState({})
    const [desde, setDesde] = useState(null)
    const [hasta, setHasta] = useState(null)
    const [desdeDescanso, setDesdeDescanso] = useState(null)
    const [hastaDescanso, setHastaDescanso] = useState(null)
    const [duracion, setDuracion] = useState(null)
    const [capacidad, setCapacidad] = useState("")
    const [fh, setFH] = useState(0)
    const [changeNumber, setChangeNumber] = useState(0)
    const [error, setError] = useState(false) 
    const [emessage, setEmessage] = useState("")
    const [success, setSuccess] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    const [servInfo, setServInfo] = useState({
      categoria: "",
      titulo: "",
      unidad: "",
      descripcion: "",
      condiciones: "",
      precio: 0,
      capacidad: 0,
      precioDomicilio: 0,
      precioDelivery: 0,
    })
    
    const [servUInfo, setServUInfo] = useState({
      condiciones: null,
      descripcion: null,
      precio: null,
      urlImagen: null,
      capacidad: null,
      unidad: null,
      domicilio: null,
      delivery: null,
    })

    const [file, setFile] = useState(null);
    const [url, setURL] = useState("");
    const [src, setImg] = useState('');
    
    const [stepStart, setStepStart] = useState(false);
    const [step1, setStep1] = useState(false);
    const [step2, setStep2] = useState(false);
    const [step3, setStep3] = useState(false);
    const [step4, setStep4] = useState(false);
    const [step5, setStep5] = useState(false);
    const [step6, setStep6] = useState(false);
    const [step7, setStep7] = useState(false);
    const [step8, setStep8] = useState(false);
    const [step9, setStep9] = useState(false);
    const [step10, setStep10] = useState(false);
  
    const handleClick = event => {
      hiddenFileInput.current.click();
    };

    async function handleChange(e) {
      var file = e.target.files[0]
      Compress.imageFileResizer(
        file,
        600,
        300,
        "JPEG",
        10,
        0,
        (uri) => {
          setFile(uri)
          console.log(uri)
        },
        "file",
        600,
        300
      )
      setImg(URL.createObjectURL(file))
    }
    
    function getCategories(){
      let tipos = []
      firebase.db.collection('CategoriasServicios').get().then(data=>{  
        data.forEach(tipo=>{
          tipos.push(tipo.id)
          tipos.sort()
        })
        // tipos.pop("Todas")
        setTiposCate(tipos)
      });
    }

    function getServicesCategories(cate){
      firebase.db.collection('CategoriasServicios').doc(cate).get().then(data=>{
        setTipoServicios(data.data().servicios)
      });
    }

    const getServiceDays = async(s) =>{
      let tipos = [];
      await firebase.db.collection("Localidades").doc(s.localidadId)
      .collection("Servicios").doc(s.servicioId).collection("Agenda").orderBy("createdOn", "asc").get().then(val=>{
        val.docs.forEach(item=>{
          let d = moment(item.data().date.toDate())
          let today = moment()
          d.isSameOrAfter(today) && tipos.push(item.data())
        })
        setAgendaDays(tipos)
      })
      setEditAgenda(true)
    }
    
    const getServices = async(id) =>{
      let tipos = [];
      let tipos2 = [];
      // await firebase.db.collection("Localidades")
      // .where("aliadoId", "==", id).get().then(val=>{
      //   val.docs.forEach(item=>{
      //     firebase.db.collection("Localidades").doc(item.data().localidadId).collection("Servicios").get().then(val=>{
      //       val.docs.forEach(item=>{
      //         tipos.push(item.data())
      //       })
      //       setServices(tipos)
      //     })
      //   })
      // })
      
      await firebase.db.collection("Localidades").where("aliadoId", "==", id).get().then(val=>{
        val.docs.forEach(item=>{
          tipos.push(item.data())
        })
      })

      Promise.all(tipos.map(async (doc) => {
        
        firebase.db.collection("Localidades").doc(doc.localidadId).collection("Servicios").get().then(val=>{
          val.docs.forEach(item=>{
            let o1 = item.data()
            o1["nombreLocalidad"] = doc.nombreLocalidad
            tipos2.push(o1)
          })
        })

      }))

      console.log(tipos)
      console.log(tipos2)

      setTimeout(() => {
        setServices(tipos2)
      }, 500);

    }
    
    const getLocalidades = async(id) =>{
      let tipos = [];
      await firebase.db.collection("Localidades")
      .where("aliadoId", "==", id).get().then(val=>{
        val.docs.forEach(item=>{
          tipos.push(item.data())
        })
        setLocalidades(tipos)    
      })
    }

    const getLPID = async(id) =>{
      await firebase.db.collection("Localidades").where("lc", "==", "Localidad Principal")
      .where("aliadoId", "==", id).get().then(val=>{
        val.docs.forEach(item=>{
          setLPID(item.data().localidadId)
        })
      })

    }
    
    const setterLocalidades = () =>{
      setLocalidadesVarias(localidades)
    }

    function checkInputs(object){
      let val = 0
      let array = []
      object["localidadesVarias"] = localidadesVarias
      object["palabrasClave"] = palabrasClave
      Object.keys(object).forEach(function(key) {
        if (object[key] === '' || object["precio"] === 0 || object.localidadesVarias.length === 0) {
          val++
          array.push(key)
        }
      });
      if(val > 0){
        setError(true)
        setEmessage("Todos los campos son requeridos")
        setTimeout(() => {
          setError(false)
        }, 4000);
        setBtnMessage("Crear servicio")
      }else{
        uploadService();
        // alert("Todos los inputs estan llenos")
      }
      return val > 0 ? true : false
    }

    const ErrorComponent = ({msg}) => {
      return (
          <div className="error-alert">
              <span className="material-icons mr-2">error</span>
              {msg}
              <div onClick={()=>{setError(false)}} className="material-icons ml-2 cursor-pointer">close</div>
          </div>
      )
    }
    
    const SuccessComponent = ({msg}) => {
      return (
          <div className="success-alert">
              <span className="material-icons mr-2">done</span>
              {msg}
              <div onClick={()=>{setSuccess(false)}} className="material-icons ml-2 cursor-pointer">close</div>
          </div>
      )
    }

    let help = [
      'Ingresa cada uno de tus servicios en la opción "Subir Servicio" y completa cada uno de los campos solicitados.',
      "LOCALIDAD – Selecciona la Localidad o las Localidades en donde se presta el servicio",
      "CATEGORIA - Selecciona la categoría del servicio",
      "PALABRA CLAVE – Ingresa palabras claves relacionadas con el servicio que puedan facilitar su búsqueda a los Dueños de las Mascotas.",
      "UNIDAD – Selecciona la unidad en la que se presta el servicio (Dia, Hora, Semana, etc.)",
      "DESCRIPCION – Escribe de que se trata el servicio",
      "CONDICIONES – Escribe las condiciones del servicio",
      "SERVICIO A DOMICILIO – Indica si aplica para tu servicio, e ingresa el costo",
      "RECOGER MASCOTA - Indica si aplica para tu servicio, e ingresa el costo",
      "MONTO – Ingresa el costo de tu servicio. El Costo debe estar alineado con la unidad seleccionada.",
    ]

    const handleKeyPress = (event) => {
      if(event.key === 'Enter' && palabra !== ""){
        setPalabrasClave([...palabrasClave, palabra])
      }
    }

    useEffect(() => {
      firebase.getCurrentUser().then((val)=>{
        getLPID(val.role !== "Administrador" && val.aliadoAdminId !== undefined ? val.aliadoAdminId : val.aliadoId)
        getServices(val.role !== "Administrador" && val.aliadoAdminId !== undefined ? val.aliadoAdminId : val.aliadoId)
        getLocalidades(val.role !== "Administrador" && val.aliadoAdminId !== undefined ? val.aliadoAdminId : val.aliadoId)
        setUser(val)
        firebase.getCountryInfo(val.pais).then((val)=>{
          setCountryInfo(val.data())
        })
      })
      getCategories()
    }, [])

    return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
        <div className="main-content-container container-fluid px-4">
          {error && <ErrorComponent msg={emessage === "" ? "Todos los campos son requeridos" : emessage}/>}
          {success && <SuccessComponent msg={successMsg === "" ? "Servicio actualizado exitosamente" : successMsg}/>}
          { deleteModal && <div className="cc-modal-wrapper fadeIn">
              <div className="c2-modal">
                  <div className="cc-modal-header">
                      <span className="mb-0 material-icons" style={{color: "var(--danger)", fontSize: "69px"}}>cancel</span>
                  </div>
                  <div className="c2-modal-body">
                     <p className="mb-0">
                         ¿Desea eliminar este servicio?
                     </p>
                  </div>
                  <div className="cc-modal-footer align-items-center justify-content-spacebetween">
                    <button onClick={()=>{setDeleteModal(false)}} className="mr-2 btn btn-outline-secondary">
                      No
                    </button>
                    <button onClick={()=>{ deleteService() }} className="ml-2 btn btn-danger">Eliminar</button>
                  </div>
              </div>
          </div>}
          { showLocalidadesModal
          ? <div className="cc-modal-wrapper fadeIn">
              <div className="cc-modal">
                <div className="cc-modal-header mb-2">
                  <div className="no-gutters mb-3 row align-items-center justify-content-spacebetween">
                    <h3 className="mb-0">Localidades</h3>
                    <div className="row no-gutters position-relative custom-control custom-checkbox">
                      <input onClick={()=>{ setterLocalidades() }} type="checkbox" className="custom-control-input" id="formsCheckboxDefault"/>
                      <label className="custom-control-label" for="formsCheckboxDefault">Todas las localidades</label>
                    </div>
                  </div>
                </div>
                <div className="cc-modal-body">
                  {localidades.map((l)=>{
                    return (
                      <div onClick={()=>{ localidadesVarias.includes(l) ? 
                        setLocalidadesVarias(localidadesVarias.filter((l1) => l1 !== l))
                      : setLocalidadesVarias([l, ...localidadesVarias]) }} className={`cc-modal-card mx-1 cursor-pointer ${localidadesVarias.includes(l) ? "active" : "" }`} style={{backgroundImage: `url(${l.locacionImg})` }} key={l.localidadId}>
                        <div className="cc-modal-card-overlay">
                          <p className="mb-0 cc-modal-card-p">
                            {l.direccionLocalidad}
                          </p>
                          <p className="mb-0 cc-modal-card-p-strong">
                            {l.nombreLocalidad}
                          </p>
                        </div>
                      </div>
                    )
                  })}
                </div>
                <div className="cc-modal-footer align-items-center justify-content-spacebetween">
                  {/* <div className={`btn ${"btn-primary"}`}> */}
                  <button onClick={()=>{setShowLocalidadesModal(false)}} className={`btn btn-disabled`}>
                    Cancelar
                  </button>
                  <button onClick={()=>{setShowLocalidadesModal(false)}} className={`btn btn-primary`}>
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          : <div></div>
          }
          { editAgenda && <div className="cc-modal-wrapper fadeIn">
              <div className="c3-modal">
                <div className="cc-modal-header mb-2">
                  <div className="no-gutters mb-3 row align-items-center justify-content-spacebetween">
                    <h3 className="mb-0">Agenda del servicio</h3>
                  </div>
                </div>
                <div className="cc-modal-body">
                  <div style={{width: "inherit"}}>
                    <div className="agenda-days-slider">
                      {agendaDays.map((d, i)=>{
                        return (
                          <p className={`${day === d && "day-active"} mb-0`} onClick={()=>{ setDay(d) }} key={i}>
                            {d.bloqueado && <> <i className="material-icons">lock</i> <br/> </>}
                            {d.fecha}
                          </p>
                        )
                      })}
                    </div>
                    <div className="row no-gutters mt-3 align-items-center justify-content-spacebetween my-3">
                      { day.agendaId !== undefined && <div onClick={()=>{ blockDay(day) }} className={`btn btn-outline-secondary col-lg-4`}>
                        {day.bloqueado ? "Desbloquear día " : "Bloquear día "}
                        <i className="material-icons">{day.bloqueado ? "lock_open" : "lock"}</i>
                      </div> }
                      { (service.tipoAgenda === "Free" && day.agendaId !== undefined) && <div className="row no-gutters align-items-center justify-content-spacebetween"> 
                          <div className="col-lg-6" ><p className="mb-0 light color-primary" >Clientes este día: </p></div>
                          <input className="form-control col-lg-6" placeholder={day.capacidadDia} value={capacidad} onChange={(e)=>{ setCapacidad(e.target.value) }} />
                        </div> }
                      { (service.tipoAgenda === "Slots" && day.agendaId !== undefined) && <div className="justify-content-spacebetween row align-items-center col-lg-8">
                          <div className="col-lg-6">
                              <p className="mb-0 color-primary">Tiempo promedio de atención</p>
                          </div>
                          <div className="col-lg-6">
                              <TimePicker placeholder="00:00" clearable ampm={false} label="" value={duracion} onChange={setDuracion}/>
                          </div>
                      </div>}
                    </div>
                    { (day.agendaId !== undefined && duracion !== null ) && <>
                      <p className="mb-2 agenda-title">Horario de atención para este día</p>
                      <div className="no-gutters mb-2 justify-content-spacebetween row align-items-center col-lg-12">
                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-lg-6">
                                    <p className="mb-0">Desde</p>
                                </div>
                                <div className="col-lg-6">
                                    <TimePicker clearable placeholder={day.horasDia !== undefined && day.horasDia[0]} ampm={false} label="" value={desde} onChange={setDesde}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-lg-6">
                                    <p className="mb-0">Hasta</p>
                                </div>
                                <div className="col-lg-6">
                                    <TimePicker placeholder={day.horasDia !== undefined && day.horasDia[day.horasDia.length - 1]} clearable ampm={false} label="" value={hasta} onChange={setHasta}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                          <button className={`btn ${ (desde === null || hasta === null) || (desde > hasta) || duracion === null ? "btn-disabled" : "btn-success"}`} onClick={()=>{
                              if(desde === null || hasta === null){
                                  setEmessage("Debes ingresar las horas correctas")
                                  setError(true)
                                  setTimeout(() => {
                                    setError(false)
                                  }, 4000);
                              }else if(desde > hasta){
                                  setEmessage("La hora inicial deber ser menor a la final")
                                  setError(true)
                                  setTimeout(() => {
                                    setError(false)
                                  }, 4000);
                              }else if(duracion === null){
                                  setEmessage("Debes iniciar el tiempo promedio de atención cuando tu agenda es por espacios de tiempo")
                                  setError(true)
                                  setTimeout(() => {
                                    setError(false)
                                  }, 4000);
                              }else{
                                  let d = moment(desde).toDate().getHours() +  ":" + moment(desde).toDate().getMinutes()
                                  let h = moment(hasta).toDate().getHours() +  ":" + moment(hasta).toDate().getMinutes()
                                  let duration = moment(duracion).toDate().getHours() +  ":" + moment(duracion).toDate().getMinutes()
                                  setDesde(desde)
                                  setHasta(hasta)
                                  setHoras(AgendaConfig.getTimes(d, h, duration))
                              }
                          }}><i className="material-icons">save</i> Generar cupos</button>
                        </div>
                      </div>
                      </> }
                      { (day.agendaId !== undefined && horas.length > 0) && <>
                      <p className="mb-2 agenda-title">Horario de descanso para este día</p>
                      <div className="no-gutters justify-content-spacebetween row align-items-center col-lg-12">
                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-lg-6">
                                    <p className="mb-0">Desde</p>
                                </div>
                                <div className="col-lg-6">
                                    <TimePicker clearable placeholder="00:00" ampm={false} label="" value={desdeDescanso} onChange={setDesdeDescanso}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-lg-6">
                                    <p className="mb-0">Hasta</p>
                                </div>
                                <div className="col-lg-6">
                                    <TimePicker placeholder="00:00" clearable ampm={false} label="" value={hastaDescanso} onChange={setHastaDescanso}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                          <button className={`btn ${ (desde === null || hasta === null && desdeDescanso === null || hastaDescanso === null) || (desde > hasta && desdeDescanso > hastaDescanso) || duracion === null ? "btn-disabled" : "btn-success"}`} onClick={()=>{
                              if(desdeDescanso === null || hastaDescanso === null){
                                  setEmessage("Debes ingresar las horas correctas")
                                  setError(true)
                                  setTimeout(() => {
                                    setError(false)
                                  }, 4000);
                              }else if(desdeDescanso > hastaDescanso){
                                  setEmessage("La hora inicial deber ser menor a la final")
                                  setError(true)
                                  setTimeout(() => {
                                    setError(false)
                                  }, 4000);
                              }else if(fh === horas.length){
                                  setEmessage("Horario de descanso implementado, intenta ingresar un nuevo horario de atención")
                                  setError(true)
                                  setTimeout(() => {
                                    setError(false)
                                  }, 4000);
                              }else if(duracion === null){
                                  setEmessage("Debes iniciar el tiempo promedio de atención cuando tu agenda es por espacios de tiempo")
                                  setError(true)
                                  setTimeout(() => {
                                    setError(false)
                                  }, 4000);
                              }else{
                                  let desde = moment(desdeDescanso).toDate().getHours() +  ":" + (moment(desdeDescanso).toDate().getMinutes() === 0 ? moment(desdeDescanso).toDate().getMinutes() + "0" : moment(desdeDescanso).toDate().getMinutes() )
                                  let hasta = moment(hastaDescanso).toDate().getHours() +  ":" + (moment(hastaDescanso).toDate().getMinutes() === 0 ? moment(hastaDescanso).toDate().getMinutes() + "0" : moment(hastaDescanso).toDate().getMinutes() )
                                  let duration = moment(duracion).toDate().getHours() +  ":" + moment(duracion).toDate().getMinutes()
                                  setHoras(AgendaConfig.restHoursFrom(horas, desde, hasta, duration))
                                  setFH(horas.length)
                                  console.log("Cantidad de horas: " + horas.length)
                              }
                          }}><i className="material-icons">save</i> Aplicar descanso</button>
                        </div>
                      </div>
                      </> }
                      { (horas.length > 0 && service.tipoAgenda === "Slots") && <div className="my-4">
                        <button onClick={()=>{ changeDaySlot(day) }} className={`btn btn-success btn-block`}>
                          Guardar nuevo horario
                        </button>
                      </div>
                      }
                      { (capacidad !==  "" && service.tipoAgenda === "Free") && <div className="my-4">
                        <button onClick={()=>{ changeDayAtention(day) }} className={`btn btn-success btn-block`}>
                          Guardar nueva capacidad del día
                        </button>
                      </div>
                      }
                      { (service.tipoAgenda === "Slots" && day.horasDia !== undefined  ) && <div className="mt-3 slots-day"> {
                          day.horasDia.map((h, i)=> <div className="pill" key={i}>{h}</div>)
                        } </div>
                      }
                  </div>
                </div>
                <div className="cc-modal-footer align-items-center justify-content-spacebetween">
                  <button onClick={()=>{
                    setEditAgenda(false); 
                    setDay({}); 
                    setAgendaDays([])
                    setDesde(null)
                    setHasta(null)
                    setDuracion(null)
                    setDesdeDescanso(null)
                    setHastaDescanso(null)
                    setHoras([])
                  }} className={`btn btn-disabled btn-block`}>
                    Cerrar
                  </button>
                  {/* <button onClick={()=>{setEditAgenda(false); setDay({}); setAgendaDays([])}} className={`btn btn-primary`}>
                    Guardar
                  </button> */}
                </div>
              </div>
            </div> }
            <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
              <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                <div className="row align-items-center">
                  <div className="ml-2 col row">
                    <p className="page-title bold"><Link className="page-title light" to="/configuration">Configuración</Link> <span>Servicios</span></p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-1 mb-0">
                <div className="row align-items-center justify-content-space-around level-2">
                  <i onClick={()=>{setStepStart(true)}} className="material-icons color-white display-5 cursor-pointer">help_outline</i>
                </div>
              </div>
            </div>

            <div className="row position-relative">
                { stepStart && <ModalGuide content={help[0]} direction="bottom" start={true} stateNext={setStep1} statePrev={setStepStart}/> }
                <div className="col-lg-7 col-md-7 col-sm-12">
                    <div className="row">
                      {
                        services.length > 0 ? services.map(service=>{
                        return(
                          <div className="col-md-6 col-sm-12" key={service.serviceId}>
                            <div  onClick={() =>{setService(service); setUpdate(false) }}  className="card card-small card-post mb-4 cursor-pointer">
                              <div className="card-post__image" style={{backgroundImage: `url(${service.urlImagen})` }}></div>
                              <div className="card-body">
                                <h5 className="card-title">
                                  <p className="text-fiord-blue mb-2">{service.titulo}</p>
                                </h5>
                                <p className="card-text-type mb-2">{service.categoria}</p>
                                <p className="card-text mb-0">{service.descripcion}</p>

                                <p style={{width: "fit-content"}} className="pill-2 rounded mb-2">{service.nombreLocalidad}</p>
                                {!service.agendaContiene && <p style={{width: "fit-content"}} className="pill-3 rounded mb-2">Sin agenda</p>}
                                <p className="card-text-price">{countryInfo.simbolo ?? " "}{service.precio}</p>
                              </div>
                            </div>
                          </div>
                          // <div className="col-md-6 col-sm-12">

                          //   <div  onClick={() => setService(service)} key={service.serviceId} style={{backgroundImage: `url(${service.urlImagen})` }} className="custom-card mb-4">
                          //     <div className="custom-card-body">
                          //       <h5 className="custom-card-title">
                          //         <p className="text-fiord-blue mb-2">{service.titulo}</p>
                          //       </h5>
                          //       <p className="custom-card-text-type mb-2">{service.categoria}</p>
                          //       <p className="custom-card-text mb-2">{service.descripcion}</p>
                          //       <p className="custom-card-text-price">{countryInfo.simbolo ?? " "}{service.precio}</p>
                          //     </div>
                          //   </div>

                          // </div>
                        )
                        }) : <div className="text-center col-lg-12"><p>No hay servicios</p></div>
                      }
                    </div>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-12">
                    { service.titulo != null && !update ? 
                    <div style={{position: "sticky", top: "70px"}} className="">
                      <div className="card">
                        <div className="card-header-img-width">
                          <img src={service.urlImagen} alt=""/>
                        </div>
                        <div onClick={()=>setService({})} className="card-close-btn">
                          <span>X</span>
                        </div>
                        <div className="px-4">
                          <div className="card-claim-box">
                            <p className="card-claim-title">{service.categoria}</p>
                            <p className="card-claim-text">{service.titulo}</p>
                          </div>
                          <div className="card-claim-box">
                            <p className="card-claim-title">Precio del servicio</p>
                            <p className="card-claim-text">{countryInfo.simbolo ?? " "}{service.precio}</p>
                          </div>
                          <div className="card-claim-box">
                            <p className="card-claim-title">Descripción del servicio</p>
                            <p className="card-claim-text">{service.descripcion}</p>
                          </div>
                          <div className="card-claim-box">
                            <p className="card-claim-title">Condiciones del servicio</p>
                            <p className="card-claim-text">{service.condiciones}</p>
                              </div>
                      
                        </div>
                        <div className="card-footer">
                          <button onClick={()=>{updateActive()}} className={`btn btn-block mb-2 ${service.activo ? "btn-outline-danger" : "btn-outline-success"}`}>{service.activo ? "Desactivar servicio" : "Activar servicio"} <span className="d-none">{changeNumber}</span> </button>
                          {service.agendaContiene ? 
                            <button onClick={()=>{ getServiceDays(service) }} className="btn btn-block mb-2 btn-outline-secondary">Agenda del servicio</button>
                          :  
                            <button onClick={()=>{
                              history.push({
                                pathname: '/configuration/services/agenda',
                                state: { all: false, serviceId: service.servicioId, localidadId: service.localidadId}
                              })
                            }} className="btn btn-block mb-2 btn-outline-secondary">Crear agenda del servicio</button>
                          }
                          <div className="row no-gutters align-items-center justify-content-spacebetween">
                              <button onClick={()=>{setDeleteModal(true)} } className="col-md-3 py-2 btn btn-outline-danger"><span class="icon-reduced material-icons">delete</span></button>
                              <button onClick={()=>{setUpdate(true); }} className="col-md-8 btn btn-primary">Editar servicio</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    : update ?
                    <form style={{position: "sticky", top: "70px"}} onSubmit={e => e.preventDefault() && false }>
                      <div className="card">
                        <div className="card-header text-center">
                          <h4>Actualizar servicio</h4>
                        </div>
                        <div onClick={()=>{ setUpdate(false);} } className="card-close-btn">
                          <span>X</span>
                        </div>
                        <div className="px-4">

                          <input type="file"
                            ref={hiddenFileInput}
                            onChange={handleChange} 
                            style={{display: 'none'}}
                          />
                          <div onClick={handleClick} className="card-update-product-img-fwidth">
                            {src !== "" ? <img src={src} alt="" /> : <img src={service.urlImagen} alt="" />}
                          </div>
                          <div className="form-group">
                            <span className="input-label">El servicio se presta por</span>
                            <select className="form-control" defaultValue={service.unidad} value={servUInfo.unidad} onChange={e => setServUInfo({...servUInfo, unidad: e.target.value})}>
                              {tipoUnidad.map(data => (
                                  <option key={data} value={data}>{data}</option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group">
                            <span className="input-label">Descripción</span>
                            <input type="text" onChange={e => setServUInfo({...servUInfo, descripcion: e.target.value})} defaultValue={service.descripcion} className="form-control"/>
                          </div>
                          <div className="form-group">
                            <span className="input-label">Condiciones</span>
                            <input type="text" onChange={e => setServUInfo({...servUInfo, condiciones: e.target.value})} defaultValue={service.condiciones} className="form-control"/>
                          </div>
                          <span className="input-label">Precio</span>
                          <div className="input-group mb-3">
                            <div className="input-group-prepend">
                              <span className="input-group-text">{countryInfo.simbolo ?? " "}</span>
                            </div>
                            <input type="number" className="form-control" defaultValue={service.precio} onChange={(e)=>{setServUInfo({...servUInfo, precio: e.target.value})}}/>
                          </div>

                          <div className="my-3 row no-gutters justify-content-space-between align-items-center">
                            <div className="col-lg-4 text-left">Servicio a domicilio</div>
                            <div className="col-lg-3 text-center">
                              <input type="checkbox" defaultChecked={service.domicilio === 0 || service.domicilio === null ? false : true} name="ab"/>
                            </div>
                            <div className="col-lg-5 text-right">
                              <div className="form-group mb-0">
                                <input type="number" onChange={(e)=>{setServUInfo({...servUInfo, domicilio: e.target.value})}} defaultValue={service.domicilio} className="form-control col-lg-12"/>
                              </div>
                            </div>
                          </div>
                          
                          <div className="my-3 row no-gutters justify-content-space-between align-items-center">
                            <div className="col-lg-4 text-left">Recoger mascota</div>
                            <div className="col-lg-3 text-center">
                              <input type="checkbox" defaultChecked={service.delivery === 0 || service.delivery === null ? false : true} name="ab"/>
                            </div>
                            <div className="col-lg-5 text-right">
                              <div className="form-group mb-0">
                                <input type="number" onChange={(e)=>{setServUInfo({...servUInfo, delivery: e.target.value})}} defaultValue={service.delivery} className="form-control col-lg-12"/>
                              </div>
                            </div>
                          </div>

                        </div>
                        <div className="card-footer">
                          <button onClick={()=>{saveUpdatePromo()}} className="btn btn-primary btn-block">Actualizar servicio</button>
                        </div>
                      </div>
                    </form>
                    :<form style={{position: "sticky", top: "70px"}} onSubmit={e => e.preventDefault() && false }>
                      <div className="card">
                        <div className="card-header text-center">
                          <h4>Subir servicio</h4>
                        </div>
                        <div className="px-4">

                          <input type="file"
                            ref={hiddenFileInput}
                            onChange={handleChange} 
                            style={{display: 'none'}}
                          />
                          <div onClick={handleClick} className="card-update-product-img-fwidth">
                            {src !== "" ? <img src={src} alt="" /> : <div className="card-header-img-upload"><p className="material-icons icon">add</p><p className="mb-0">Cargar imagen</p></div>}
                          </div>
                          <p className="mt-3 mb-3 text-muted text-center light">Dimensiones recomendadas (600 x 300)</p>
                          <div className="position-relative form-row mb-3 align-items-center justify-content-spacebetween">
                            { step1 && <ModalGuide content={help[1]} direction="left" stateNext={setStep2} statePrev={setStep1}/> }
                            <button onClick={()=>{setShowLocalidadesModal(true)}} className="btn btn-primary btn-block">Seleccionar localidad</button>
                          </div>
                          <div className="position-relative form-row mb-3 align-items-center justify-content-spacebetween">
                            { step2 && <ModalGuide content={help[2]} direction="left" stateNext={setStep3} statePrev={setStep2}/> }
                            <select className="form-control col-lg-12" value={servInfo.categoria} onChange={(e) =>{ setServInfo({...servInfo, categoria: e.target.value}); getServicesCategories(e.target.value) } }>
                              <option value="">Categoría del servicio:</option>
                              {tiposCate.map(data => (
                                <option key={data} value={data}>{data}</option>
                              ))}
                            </select>
                          </div>
                          {servInfo.categoria === "" ? <div></div> : <div className="form-group">
                            <select className="form-control" value={servInfo.titulo} onChange={e => setServInfo({...servInfo, titulo: e.target.value})}>
                              <option>Selecciona el servicio:</option>
                              {tipoServicios.map(data => (
                                <option key={data} value={data}>{data}</option>
                                ))}
                            </select>
                          </div>}
                          <div className="form-row mb-3 align-items-center justify-content-spacebetween">
                            { step3 && <ModalGuide content={help[3]} direction="left" stateNext={setStep4} statePrev={setStep3}/> }
                            <div className={`form-row ${palabra !== "" ? "col-lg-7" : "col-lg-10"}`}>
                              <input type="text" onKeyPress={handleKeyPress} onChange={e=>{setPalabra(e.target.value)}} placeholder="Palabra clave" className="form-control"/>
                            </div>
                            { palabra !== "" ?
                            <div className="col-lg-3">
                              <span onClick={()=>{ setPalabrasClave([...palabrasClave, palabra]) }} className="btn btn-primary btn-block">+</span>
                            </div>
                            : <div></div> }
                          </div>
                          <div className="px-3 row">
                            {palabrasClave.map(p => (
                              <p className="pill" key={p}>{p} <span className="cursor-pointer btn-delete" onClick={()=>{ setPalabrasClave(palabrasClave.filter((p1) => p1 !== p)); }} >X</span></p>
                              ))}
                          </div>
                          <div className="position-relative form-row mb-3 align-items-center justify-content-spacebetween">
                            { step4 && <ModalGuide content={help[4]} direction="left" stateNext={setStep5} statePrev={setStep4}/> }
                            <select className="form-control col-lg-12" value={servInfo.unidad} onChange={e => setServInfo({...servInfo, unidad: e.target.value})}>
                              {tipoUnidad.map(data => (
                                <option key={data} value={data}>{data}</option>
                              ))}
                            </select>
                          </div>
                          <div className="form-row mb-3 align-items-center justify-content-spacebetween">
                            { step5 && <ModalGuide content={help[5]} direction="left" stateNext={setStep6} statePrev={setStep5}/> }
                            <input type="text" onChange={e => setServInfo({...servInfo, descripcion: e.target.value})} placeholder="Descripción del servicio" className="form-control col-lg-12"/>
                          </div>
                          <div className="form-row mb-3 align-items-center justify-content-spacebetween">
                            { step6 && <ModalGuide content={help[6]} direction="left" stateNext={setStep7} statePrev={setStep6}/> }
                            <input type="text" onChange={e => setServInfo({...servInfo, condiciones: e.target.value})} placeholder="Condiciones del servicio" className="form-control col-lg-12"/>
                          </div>
                          <div className="my-3 row no-gutters justify-content-space-between align-items-center">
                            { step7 && <ModalGuide content={help[7]} direction="left" stateNext={setStep8} statePrev={setStep7}/> }
                            <div className="col-lg-4 text-left">Servicio a domicilio</div>
                            <div className="col-lg-3 text-center">
                              <input type="checkbox" onClick={()=>{setDomicilio(!domicilio)}} name="ad"/>
                            </div>
                            <div className="col-lg-5 text-right">
                              <div className="form-group mb-0">
                                {domicilio
                                  ?
                                  <div className="input-group">
                                    <div className="input-group-prepend">
                                      <span className="input-group-text">{countryInfo.simbolo ?? " "}</span>
                                    </div>
                                    <input type="text" onChange={(e)=>{setServInfo({...servInfo, precioDomicilio: e.target.value})}} placeholder="Ingresar costo" className="form-control"/>
                                  </div>
                                  :
                                  <div className="input-group">
                                    <div className="input-group-prepend">
                                      <span className="input-group-text">{countryInfo.simbolo ?? " "}</span>
                                    </div>
                                    <input type="text" disabled="true" onChange={(e)=>{setServInfo({...servInfo, precioDomicilio: e.target.value})}} placeholder="Ingresar costo" className="form-control"/>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                          <div className="my-3 row no-gutters justify-content-space-between align-items-center">
                            { step8 && <ModalGuide content={help[8]} direction="left" stateNext={setStep9} statePrev={setStep8}/> }
                            <div className="col-lg-4 text-left">Recoger mascota</div>
                            <div className="col-lg-3 text-center">
                              <input type="checkbox" onClick={()=>{setDelivery(!delivery)}} name="ad"/>
                            </div>
                            <div className="col-lg-5 text-right">
                              <div className="form-group mb-0">
                                {delivery
                                  ?
                                  <div className="input-group">
                                    <div className="input-group-prepend">
                                      <span className="input-group-text">{countryInfo.simbolo ?? " "}</span>
                                    </div>
                                    <input type="text" onChange={(e)=>{setServInfo({...servInfo, precioDelivery: e.target.value})}} placeholder="Ingresar costo" className="form-control"/>
                                  </div>
                                  :
                                  <div className="input-group">
                                    <div className="input-group-prepend">
                                      <span className="input-group-text">{countryInfo.simbolo ?? " "}</span>
                                    </div>
                                    <input type="text" disabled="true" onChange={(e)=>{setServInfo({...servInfo, precioDelivery: e.target.value})}} placeholder="Ingresar costo" className="form-control"/>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                          <div className="form-row input-group mb-3 align-items-center justify-content-spacebetween">
                            { step9 && <ModalGuide content={help[9]} direction="left" last={true}  stateNext={setStep9} statePrev={setStep9}/> }
                            <div className="input-group-prepend">
                              <span className="input-group-text">{countryInfo.simbolo ?? " "}</span>
                            </div>
                            <input type="text" className="form-control" placeholder="Precio del servicio" onChange={(e)=>{setServInfo({...servInfo, precio: e.target.value})}}  value={servInfo.precio} />
                          </div>
                        </div>
                        <div className="my-3 input-group justify-content-space-between align-items-center">
                          <div className="col-lg-10 text-left">¿El servicio contiene agenda?</div>
                          <div className="col-lg-2 text-center">
                            <input type="checkbox" onClick={()=>{setContieneAgenda(!contieneAgenda)}} name="ad"/>
                          </div>
                        </div>
                        <div className="card-footer">
                          <button onClick={()=>{checkInputs(servInfo)}} className="btn btn-primary btn-block">{btnMessage}</button>
                        </div>
                      </div>
                    </form>}
                </div>
            </div>

          </div>
        </MuiPickersUtilsProvider>
    )

    async function uploadService() {
      setBtnMessage("Subiendo...")
      let date = moment().toDate().toUTCString()
      // await firebase.db.collection("Localidades").doc(LPID).update({
      //   serviciosContiene: true
      // })
      let id = firebase.db.collection("Localidades").doc(LPID).collection("Servicios").doc().id
      try {
        await firebase.storage.ref(`/Servicios imagenes/${file.name}`).put(file)
        firebase.storage.ref("Servicios imagenes").child(file.name).getDownloadURL().then((urlI) => {
          if(localidadesVarias.length > 0){
            localidadesVarias.forEach(localidad=>{
              uploadPart(id, localidad.localidadId, urlI)

              firebase.db.collection("Localidades").doc(localidad.localidadId).update({
                serviciosContiene: true
              })

            })
            setBtnMessage("Listo");
            if(!contieneAgenda){
              getServices(user.aliadoId)
              setTimeout(() => {
                // window.location.href = "/configuration/services"
              }, 1000);
            }else{
              history.push({
                pathname: "/configuration/services/agenda", 
                state: { all: true, serviceId: id}
              })
            }
          }else{
            if(LPID === localidadId){
              uploadPart(id, LPID, urlI).then((val)=>{
                firebase.db.collection("Localidades").doc(LPID).update({
                  serviciosContiene: true
                })
                setBtnMessage("Listo");
                if(!contieneAgenda){
                  getServices(user.aliadoId)
                  setTimeout(() => {
                    // window.location.href = "/configuration/services"
                  }, 1000);
                }else{
                  history.push({
                    pathname: '/configuration/services/agenda',
                    state: { all: false, serviceId: id, localidadId: LPID}
                  })
                }
              })
            }else{
              firebase.db.collection("Localidades").doc(localidadId).update({
                serviciosContiene: true
              })
              firebase.db.collection("Localidades").doc(LPID).update({
                serviciosContiene: true
              })
              uploadPart(id, localidadId, urlI)
              uploadPart(id, LPID, urlI).then((val)=>{
                setBtnMessage("Listo");
                if(!contieneAgenda){
                  getServices(user.aliadoId)
                  setTimeout(() => {
                    // window.location.href = "/configuration/services"
                  }, 1000);
                }else{
                  history.push({
                    pathname: "/configuration/services/agenda", 
                    state: { all: false, serviceId: id, listLocalidades: [LPID, localidadId], noPrincipal: true}
                  })
                }
              })
            }
  
          }
        })
      } catch(error) {
        alert(error.message)
      }
    }

    async function uploadPart(id, lid, urlImagen){
      await firebase.db.collection("Localidades").doc(lid).collection("Servicios").doc(id).set({
        isApproved: false,
        agendaContiene: false,
        aliadoId: user.aliadoId,
        categoria: servInfo.categoria,
        condiciones: servInfo.condiciones,
        descripcion: servInfo.descripcion,
        precio: parseFloat(servInfo.precio),
        localidadId: lid,
        servicioId: id,
        palabrasClave: palabrasClave,
        urlImagen: urlImagen,
        titulo: servInfo.titulo,
        capacidad:  parseInt(servInfo.capacidad),
        unidad: servInfo.unidad,
        domicilio: !domicilio ? null : parseFloat(servInfo.precioDomicilio),
        delivery: !delivery ? null : parseFloat(servInfo.precioDelivery),
        createdOn: moment().toDate(),
      })
      console.log("Listo")
    }
      
    async function saveUpdatePromo(){
      if(file){
        try {
          await firebase.storage.ref(`/Servicios imagenes/${file.name}`).put(file)
          firebase.storage.ref("Servicios imagenes").child(file.name).getDownloadURL().then((urlI) => {
            firebase.db.collection('Localidades').doc(service.localidadId).collection("Servicios").doc(service.servicioId).update({
              condiciones: servUInfo.condiciones,
              descripcion: servUInfo.descripcion,
              precio: servUInfo.precio !== null ? parseFloat(servUInfo.precio) : service.precio,
              urlImagen: urlI,
              unidad: servUInfo.unidad ?? service.unidad,
              domicilio: servUInfo.domicilio ?? service.domicilio,
              delivery: servUInfo.delivery ?? service.delivery,
            })
          })
        } catch (e) {
          alert(e.message)
        }
      }else{
        await firebase.db.collection('Localidades').doc(service.localidadId).collection("Servicios").doc(service.servicioId).update({
          condiciones: servUInfo.condiciones ?? service.condiciones,
          descripcion: servUInfo.descripcion ?? service.descripcion,
          precio: servUInfo.precio !== null ? parseFloat(servUInfo.precio) : service.precio,
          unidad: servUInfo.unidad ?? service.unidad,
          domicilio: servUInfo.domicilio ??service.domicilio,
          delivery: servUInfo.delivery ??service.delivery,
        })
      }
      setSuccessMsg("Servicio actualizado exitosamente")
      setSuccess(true)
      getServices(user.aliadoId)
      setUpdate(false)
      setService({})
      setTimeout(() => {
        setSuccess(false)
      }, 4000);
    }

    async function blockDay(d){
      try{
        await firebase.db.collection("Localidades").doc(service.localidadId).collection("Servicios").doc(service.servicioId).collection("Agenda").doc(d.fecha).update({
          bloqueado: d.bloqueado ? false : true
        })
        getServiceDays(service)
        setDay(d)
      }catch(e){
        console.log(`Error: ${e}`)
      }
    }
    
    async function changeDaySlot(d){
      try{
        await firebase.db.collection("Localidades").doc(service.localidadId).collection("Servicios").doc(service.servicioId).collection("Agenda").doc(d.fecha).update({
          horasDia: horas
        })
        getServiceDays(service)
        setDesde(null)
        setHasta(null)
        setDuracion(null)
        setDesdeDescanso(null)
        setHastaDescanso(null)
        setHoras([])
      }catch(e){
        console.log(`Error: ${e}`)
      }
    }
    
    async function changeDayAtention(d){
      try{
        await firebase.db.collection("Localidades").doc(service.localidadId).collection("Servicios").doc(service.servicioId).collection("Agenda").doc(d.fecha).update({
         capacidadDia: parseInt(capacidad)
        })
        getServiceDays(service)
        setDesde(null)
        setHasta(null)
        setDuracion(null)
        setDesdeDescanso(null)
        setHastaDescanso(null)
        setCapacidad("")
      }catch(e){
        console.log(`Error: ${e}`)
      }
    }
    
    async function updateActive(){
      try{
        await firebase.db.collection("Localidades").doc(service.localidadId).collection("Servicios").doc(service.servicioId).update({
          activo: service.activo ? false : true
        })
        service.activo = service.activo ? false : true
        setTimeout(() => {
          setChangeNumber( changeNumber + 1 )
        }, 100);
      }catch(e){
        console.log(`Error: ${e}`)
      }
    }

    async function deleteService(){      
      try{
        await firebase.db.collection('Localidades').doc(service.localidadId).collection("Servicios").doc(service.servicioId).collection("Agenda").get().then((val)=>{
          let data = []
          val.docs.forEach((ds)=>{
            data.push(ds.data().fecha)
          })
          data.forEach((d) => {
            firebase.db.collection('Localidades').doc(service.localidadId).collection("Servicios").doc(service.servicioId).collection("Agenda").doc(d).delete().then((val)=>{
              console.log("Eliminado: " + d)
            })
          })
        })
        await firebase.db.collection('Localidades').doc(service.localidadId).collection("Servicios").doc(service.servicioId).delete().then((val)=>{
          setDeleteModal(false)
          setSuccessMsg("Servicio eliminado exitosamente")
          setSuccess(true)
          getServices(user.aliadoId)
          setService({})
          setTimeout(() => {
            setSuccess(false)
          }, 4000);
        })
      }catch(e){
        console.log("Error: " + e);
      }
    }

}

export default Services